import { makeAutoObservable, runInAction } from "mobx";
import { db } from '@stores/environments/Database.web';
import { ref, get, child, update } from "firebase/database";
import { User } from "@interfaces/iuser";

class UserStore {
  users: User[] = [];
  loading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchUsers = async () => {
    this.loading = true;
    const dbRef = ref(db);

    try {
      const snapshot = await get(child(dbRef, 'users'));
      if (snapshot.exists()) {
        const data = snapshot.val();
        const allUsers: User[] = Object.keys(data).map((key) => ({
          uid: key,
          ...data[key].info,
        }));

        runInAction(() => {
          this.users = allUsers;
          this.loading = false;
        });
      } else {
        runInAction(() => {
          this.users = [];
          this.loading = false;
        });
      }
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  updateUserData = async (user: User) => {
    runInAction(() => {
      this.loading = true;
    });
    const dbRef = ref(db);

    try {
      await update(child(dbRef, `users/${user.uid}/info`), { ...user });

      const newUsers = this.users.map((u) => (u.uid === user.uid ? user : u));

      runInAction(() => {
        this.users = newUsers;
        this.loading = false;
      });
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

export const userStore = new UserStore();
